import { Action } from "@ngrx/store";
import { ReduxAction } from "./../actions/redux.action";
import { UserStaff } from "./../models/user-staff.model";

export function OfficeStaffReducer(state: UserStaff, action: ReduxAction) {
  switch (action.type) {
    case "SET_OFFICE_STAFF_INFO":
      return Object.assign({}, state, action.get());

    case "CLEAR_OFFICE_STAFF":
    case "LOGOUT":
      return null;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/reducers/office-staff.reducer.ts